export default "__VITE_ASSET__hesnys$B__"